import { type ErrorResponse } from '@/hooks/common/useError';
import useReactQuery from '@/hooks/common/useReactQuery';
import { type AccountRegistrationFormValues } from '@/interfaces/registration';

interface EmailRegistrationTokenResponse {
  parent_email_registration_token_id: string;
}

const useRequestRegistrationTokens = () => {
  const { useMutation } = useReactQuery();
  const mutation = useMutation<EmailRegistrationTokenResponse>({
    method: 'POST',
    url: '/api/school/parents_v3/email_registration_tokens',
  });

  const sendRegistrationToken = (
    formValues: Omit<AccountRegistrationFormValues, 'password_confirmation'>,
    onSuccess?: (data?: EmailRegistrationTokenResponse) => void,
    onError?: (error: ErrorResponse) => void,
    parentEmailRegistrationTokenId?: string,
  ) => {
    const requestBody = parentEmailRegistrationTokenId
      ? {
          ...formValues,
          parent_email_registration_token_id: parentEmailRegistrationTokenId,
        }
      : { ...formValues };

    mutation.mutate(JSON.stringify(requestBody), {
      onSuccess,
      onError,
    });
  };

  return {
    sendRegistrationToken,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};

export default useRequestRegistrationTokens;
